export default () =>
  import(
    /* webpackChunkName: 'coffee/activities/ad-invite-register' */ './AdInviteRegister'
  );
